import { render, staticRenderFns } from "./LoginMenuButtonNew.vue?vue&type=template&id=d30561d4&scoped=true"
import script from "./LoginMenuButtonNew.vue?vue&type=script&lang=ts"
export * from "./LoginMenuButtonNew.vue?vue&type=script&lang=ts"
import style0 from "./LoginMenuButtonNew.vue?vue&type=style&index=0&id=d30561d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d30561d4",
  null
  
)

export default component.exports